import {
  Box,
  Button,
  ButtonSize,
  ButtonVariant,
  Color,
  Dialog,
  FontWeight,
  H3,
  Interpose,
  Space,
  Text,
  TypePreset,
} from "@gocardless/flux-react";

import { Currency } from "src/common/currencies";

interface BankDetailsDialogProps {
  isOpen: boolean;
  accountName?: string;
  accountNumberEnding?: string;
  branchCodeEnding?: string;
  currency?: Currency;
  accountBalance?: string;
  closeDialog: () => void;
}

const BankDetailsDialog: React.FC<BankDetailsDialogProps> = ({
  isOpen,
  accountName,
  accountNumberEnding,
  branchCodeEnding,
  currency,
  accountBalance,
  closeDialog,
}) => {
  const maskedAccountNumber = accountNumberEnding
    ? `*****${accountNumberEnding}`
    : "";
  const maskedBranchCode = branchCodeEnding ? `****${branchCodeEnding}` : "";
  const displayBalance = `£ ${accountBalance}`;
  const bankDataMap: { label: string; value?: string }[] = [
    { label: "Account name", value: accountName },
    { label: "Account sort code", value: maskedBranchCode },
    { label: "Account number", value: maskedAccountNumber },
    { label: "Account currency", value: currency },
    { label: "Account balance", value: displayBalance },
  ];

  return (
    <Dialog
      open={isOpen}
      closeAction={{ label: "Close", onClose: closeDialog }}
      header={
        <H3 preset={TypePreset.Heading_03}>Payout account information</H3>
      }
      footer={
        <Button
          variant={ButtonVariant.PrimaryOnLight}
          size={ButtonSize.Sm}
          onClick={closeDialog}
        >
          Back
        </Button>
      }
    >
      <Text color={Color.Dawn_1400}>
        We view this data to verify the bank account is owned by the individual
        or business entered in the GoCardless set up, and so you can check we’ll
        be paying out to the correct bank account.
      </Text>
      <Space v={2} />
      <Interpose node={<Space v={[1.5, null, 1]} />}>
        {bankDataMap.map((bankData, i) => (
          <Box key={i} layout="flex" flexDirection={["column", null, "row"]}>
            <Box minWidth={[null, null, "190px"]} spaceBelow={[0.25, null, 0]}>
              <Text>{bankData.label}</Text>
            </Box>
            <Text weight={FontWeight.SemiBold}>{bankData.value}</Text>
          </Box>
        ))}
      </Interpose>
    </Dialog>
  );
};

export default BankDetailsDialog;
